export interface RuntimeEndpoints {
  webSocketUrl: string;
  playerHostRelayUrl: string;
  apiBaseUrl: string;
  source: "query" | "build" | "same-origin";
  networkMode: "player-host" | "dedicated";
}

export function resolveRuntimeEndpoints(): RuntimeEndpoints {
  const pageUrl = new URL(window.location.href);
  const queryValue = pageUrl.searchParams.get("server")?.trim();
  const buildValue = (
    import.meta.env.VITE_GAME_SERVER_URL as string | undefined
  )?.trim();
  const configured = queryValue || buildValue;
  const webSocketUrl = normalizeGameServerUrl(configured, pageUrl);
  const requestedMode =
    pageUrl.searchParams.get("network")?.trim() ||
    (import.meta.env.VITE_NETWORK_MODE as string | undefined)?.trim();

  return {
    webSocketUrl,
    playerHostRelayUrl: toPlayerHostRelayUrl(webSocketUrl),
    apiBaseUrl: toApiBaseUrl(webSocketUrl),
    source: queryValue ? "query" : buildValue ? "build" : "same-origin",
    networkMode: requestedMode === "dedicated" ? "dedicated" : "player-host",
  };
}

export function normalizeGameServerUrl(
  configured: string | undefined,
  pageUrl: URL,
): string {
  const candidate = configured
    ? new URL(configured, pageUrl)
    : new URL("/game-ws", pageUrl);

  if (candidate.protocol === "http:") {
    candidate.protocol = "ws:";
  } else if (candidate.protocol === "https:") {
    candidate.protocol = "wss:";
  }

  if (candidate.protocol !== "ws:" && candidate.protocol !== "wss:") {
    throw new Error("游戏服务器地址必须使用 ws、wss、http 或 https 协议。");
  }
  if (pageUrl.protocol === "https:" && candidate.protocol !== "wss:") {
    throw new Error("HTTPS 页面只能连接加密的 wss 游戏服务器。");
  }
  if (candidate.pathname === "/" || candidate.pathname === "") {
    candidate.pathname = "/game-ws";
  }

  candidate.hash = "";
  return candidate.toString();
}

export function toApiBaseUrl(webSocketUrl: string): string {
  const url = new URL(webSocketUrl);
  url.protocol = url.protocol === "wss:" ? "https:" : "http:";
  url.pathname = "/";
  url.search = "";
  url.hash = "";
  return url.toString();
}

export function toPlayerHostRelayUrl(webSocketUrl: string): string {
  const url = new URL(webSocketUrl);
  url.pathname = "/host-relay";
  url.search = "";
  url.hash = "";
  return url.toString();
}

export function createEndpointStorageKey(webSocketUrl: string): string {
  const url = new URL(webSocketUrl);
  return encodeURIComponent(`${url.origin}${url.pathname}`);
}
